"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.letterSpacing = exports.fontFamily = exports.isMedia = exports.omitCssProps = exports.addCssProp = exports.pageMargins = exports.contentWrapper = exports.padding = exports.margin = exports.extrabold = exports.semibold = exports.regular = exports.fontWeight = exports.lineHeight = exports.getLineHeight = exports.fontSize = exports.getFontSize = exports.mediaMax = exports.media = exports.contentWidth = exports.pageMargin = exports.breakpoint = exports.breakpoints = exports.typography = exports.spacing = exports.color = exports.background = void 0;

var _configuration = require("../../configuration");

var web = _interopRequireWildcard(require("./web"));

var _native = _interopRequireWildcard(require("./native"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _ref = (0, _configuration.platformSwitch)({
  web: web,
  "native": _native
}) || {},
    background = _ref.background,
    color = _ref.color,
    spacing = _ref.spacing,
    typography = _ref.typography,
    breakpoints = _ref.breakpoints,
    breakpoint = _ref.breakpoint,
    pageMargin = _ref.pageMargin,
    contentWidth = _ref.contentWidth,
    media = _ref.media,
    mediaMax = _ref.mediaMax,
    getFontSize = _ref.getFontSize,
    fontSize = _ref.fontSize,
    getLineHeight = _ref.getLineHeight,
    lineHeight = _ref.lineHeight,
    fontWeight = _ref.fontWeight,
    regular = _ref.regular,
    semibold = _ref.semibold,
    extrabold = _ref.extrabold,
    margin = _ref.margin,
    padding = _ref.padding,
    contentWrapper = _ref.contentWrapper,
    pageMargins = _ref.pageMargins,
    addCssProp = _ref.addCssProp,
    omitCssProps = _ref.omitCssProps,
    isMedia = _ref.isMedia,
    fontFamily = _ref.fontFamily,
    letterSpacing = _ref.letterSpacing;

exports.letterSpacing = letterSpacing;
exports.fontFamily = fontFamily;
exports.isMedia = isMedia;
exports.omitCssProps = omitCssProps;
exports.addCssProp = addCssProp;
exports.pageMargins = pageMargins;
exports.contentWrapper = contentWrapper;
exports.padding = padding;
exports.margin = margin;
exports.extrabold = extrabold;
exports.semibold = semibold;
exports.regular = regular;
exports.fontWeight = fontWeight;
exports.lineHeight = lineHeight;
exports.getLineHeight = getLineHeight;
exports.fontSize = fontSize;
exports.getFontSize = getFontSize;
exports.mediaMax = mediaMax;
exports.media = media;
exports.contentWidth = contentWidth;
exports.pageMargin = pageMargin;
exports.breakpoint = breakpoint;
exports.breakpoints = breakpoints;
exports.typography = typography;
exports.spacing = spacing;
exports.color = color;
exports.background = background;